















































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import MaterialsListPrintTool from '@/components/MaterialsListPrintTool.vue';
import HelpContent from '../HelpContent.vue';

@Component({
    components: {
        MaterialsListPrintTool,
        HelpContent,
    }
})
export default class MaterialsSearch extends Vue {
    freeText = null;
    firstSearch: boolean = false;
    showLoading: boolean = false;
    modal_helpMaterialSearch: string = "modal-helpMaterialSearch"
    page: number = 1;
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    resetSearch() {
        this.resultsItems.resultPage = new Array();
        this.page = 1;
    }
    async searchItems(start: boolean) {
        
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/material/GetMaterialsWithFilter'),
                data: {
                    FreeText: this.freeText,
                    CurrentPage: this.page,
                    Username: this.$store.getters.getUser.Username
                },
                withCredentials: true,
                responseType: 'json'
            });
            
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            this.firstSearch = true;
            this.page += 1;

            this.showLoading = false;
        } catch (error) {

            General.HandleError(error, this);
        }
        
    }
}
